import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { FiHome, FiMenu } from 'react-icons/fi';
import { FaChevronLeft } from 'react-icons/fa';
import TranspozeLogo from './TranspozeLogo.svg';
import TranspozeTitle from './TranspozeTitle.svg';

const sidebarItems = [
  { path: '/', label: 'Dashboard', icon: FiHome },
];

const Sidebar = ({ isOpen, setIsOpen }) => {
  const location = useLocation();

  const sidebarClasses = `
    fixed md:relative
    bg-white h-screen border-r transition-all duration-300 ease-in-out
  ${isOpen ? 'w-80 translate-x-0 z-30 md:z-auto' : 'w-0 -translate-x-full md:w-16 md:translate-x-0 md:z-auto'} 
    top-0 bottom-0
  `;

  const handleLinkClick = () => {
    localStorage.removeItem('globalStartDate');
    localStorage.removeItem('globalEndDate');
    if (window.innerWidth < 768) {
      setIsOpen(false);
    }
  };

  return (
    <div className={sidebarClasses}>
      <div className="flex flex-col h-full"
      style={{boxShadow: '2px 0 10px rgba(0, 0, 0, 0.1)'}}>
        {/* Close Button */}
        {isOpen && (
          <div
            className="absolute -right-3 top-10 z-30"
            onClick={() => setIsOpen(false)}
          >
            <button className="w-7 h-7 rounded-full border border-gray-300 bg-white shadow-sm flex items-center justify-center text-gray-600 hover:text-black">
              <FaChevronLeft size={12} />
            </button>
          </div>
        )}

        {/* Sidebar Header with Logo */}
        <div className="flex items-center px-2.5 pt-2.5 pb-2.5 border-b">
          {isOpen ? (
            <>
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-gray-600 rounded-md md:hidden"
                aria-label="Toggle sidebar"
              >
              </button>
              <img src={TranspozeLogo} alt="Transpoze Logo" className="h-8 mr-2 ml-2" />
              <img src={TranspozeTitle} alt="Transpoze Title" className="h-4" />
            </>
          ) : (
            <div className="hidden md:flex justify-center w-full pt-0">
              <button
                onClick={() => setIsOpen(true)}
                className="flex items-center justify-center w-9 h-9 rounded-md hover:bg-gray-100 text-gray-700"
              >
                <img src="/images/logopng.png" alt="Transpoze Logo" className="h-8" />
              </button>
            </div>
          )}
        </div>

        {/* Sidebar Menu */}
        <nav className="flex-1 px-2 overflow-y-auto">
          <ul className="p-0 mt-2">
            {sidebarItems.map((item, index) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <li key={index} className="mb-2 w-full p-1 font-[Archivo]">
                  <Link
                    to={item.path}
                    className={`flex items-center p-2 rounded-md cursor-pointer no-underline
                      ${isActive ? 'bg-[#F4F8FF] text-black font-semibold' : 'text-gray-800 hover:bg-gray-100'}`}
                    onClick={handleLinkClick}
                  >
                    <Icon className="text-xl flex-shrink-0" />
                    {isOpen && (
                      <span className="ml-4 text-md font-semibold font-[Archivo]">
                        {item.label}
                      </span>
                    )}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;